export const sidebarRoles: Record<string, string[]> = {
  admin: ["Users", "Websites", "Products"],
  editor: ["Websites", "Products"],
  viewer: ["Products"],
};
